// ======================================
// FAQ Page Module
// ======================================

import { icons } from '../components.js';

const faqCategories = [
  {
    name: 'General',
    faqs: [
      { q: 'What services does Namma Veetu Interiors offer?', a: 'We offer comprehensive interior design services including modular kitchens, wardrobes, full-home interiors, luxury interiors, renovation services, and custom furniture. Our services cover everything from consultation and 3D design to manufacturing and installation.' },
      { q: 'Which cities do you serve?', a: 'We currently serve Chennai, Coimbatore, Madurai, and Bangalore. We are expanding across Tamil Nadu and South India. Contact us to check service availability in your area.' },
      { q: 'How long does a typical project take?', a: 'A standard modular kitchen takes 30-45 days from design approval. Full-home interiors typically take 45-90 days depending on the scope. We guarantee timelines in our contract.' },
      { q: 'Do you provide a free consultation?', a: 'Yes! We offer a completely free design consultation. Our expert will visit your home, understand your requirements, and provide initial design ideas — all at no cost or obligation.' }
    ]
  },
  {
    name: 'Pricing & Payment',
    faqs: [
      { q: 'How much does interior design cost?', a: 'Our packages start from ₹3.5 lakhs for essential 2BHK interiors. Premium packages start at ₹5.5 lakhs and luxury from ₹8.5 lakhs. Use our online Cost Estimator for an instant quote based on your specific requirements.' },
      { q: 'Are there any hidden charges?', a: 'Absolutely not. We follow transparent pricing with a detailed Bill of Quantities (BOQ). Every item, material, and service charge is listed upfront. The price you see is the price you pay.' },
      { q: 'What payment methods do you accept?', a: 'We accept bank transfers, UPI, cheques, and online payments via Razorpay. We offer a structured payment plan: 10% at booking, 40% at design approval, 40% during installation, and 10% at handover.' },
      { q: 'Do you offer EMI or financing?', a: 'Yes, we partner with leading NBFCs to offer 0% EMI options for up to 12 months on select packages. Longer EMI terms are also available with nominal interest.' }
    ]
  },
  {
    name: 'Design & Materials',
    faqs: [
      { q: 'Can I customize the designs?', a: 'Absolutely! Every design is custom-made for your space. We offer unlimited design revisions until you\'re 100% satisfied. Our designers work closely with you to match your style and preferences.' },
      { q: 'What materials do you use?', a: 'We use only premium-grade materials: BWR/BWP grade plywood, HAFELE/Hettich hardware, Merino/Greenlam laminates, and premium solid surface countertops. All materials come with manufacturer warranties.' },
      { q: 'Do you provide 3D visualizations?', a: 'Yes! We provide photorealistic 3D renders and virtual walkthroughs of your space. You can see exactly how your home will look before any work begins.' },
      { q: 'Can I visit your factory?', a: 'Yes, we welcome factory visits. You can see our manufacturing process firsthand and inspect the quality of materials and workmanship.' }
    ]
  },
  {
    name: 'Warranty & Support',
    faqs: [
      { q: 'What warranty do you provide?', a: 'We offer a comprehensive 10-year warranty on all modular installations covering manufacturing defects, hardware, and structural integrity. Individual components also carry their manufacturer warranties.' },
      { q: 'What does the warranty cover?', a: 'The warranty covers: structural defects in modular units, hardware malfunctions (hinges, slides, channels), laminate peeling or warping, and soft-close mechanism failures. Normal wear and tear is excluded.' },
      { q: 'How do I request warranty service?', a: 'Simply call our support line or submit a request through your customer dashboard. Our team will schedule a service visit within 48 hours for warranty claims.' },
      { q: 'Do you provide after-sales support?', a: 'Yes! We provide dedicated after-sales support including annual maintenance checks, quick-response service team, and a customer helpline available Monday to Saturday.' }
    ]
  }
];

export function renderFAQPage() {
  return `
    <section class="page-header" style="background: linear-gradient(135deg, var(--color-primary), var(--color-secondary)); color: white;">
      <div class="container">
        <div class="page-header-content" style="text-align:center;">
          <p style="color: var(--color-accent-light); font-weight: 600; letter-spacing: 0.1em; text-transform: uppercase; margin-bottom: var(--space-4);">Support</p>
          <h1 class="page-title" style="color:white;">Frequently Asked Questions</h1>
          <p class="page-subtitle" style="color: rgba(255,255,255,0.85); max-width: 640px; margin: 0 auto;">
            Everything you need to know about our interior design services.
          </p>
        </div>
      </div>
    </section>

    <!-- FAQ Search -->
    <section style="padding: var(--space-12) 0 0;">
      <div class="container" style="max-width: var(--max-width-narrow);">
        <div style="position: relative; margin-bottom: var(--space-12);">
          <input type="text" id="faq-search" placeholder="Search your question..." style="width: 100%; padding: var(--space-4) var(--space-6); padding-left: 48px; border-radius: var(--radius-full); border: 2px solid var(--color-border); font-size: var(--text-lg); font-family: var(--font-body); transition: border-color 0.3s ease; outline: none;" onfocus="this.style.borderColor='var(--color-primary)'" onblur="this.style.borderColor='var(--color-border)'">
          <span style="position: absolute; left: 16px; top: 50%; transform: translateY(-50%); color: var(--color-text-muted);">${icons.eye}</span>
        </div>
      </div>
    </section>

    <!-- FAQ Categories -->
    <section style="padding: 0 0 var(--space-20);">
      <div class="container" style="max-width: var(--max-width-narrow);">
        ${faqCategories.map(cat => `
          <div class="faq-category" style="margin-bottom: var(--space-12);">
            <h2 style="font-family: var(--font-heading); font-size: var(--text-2xl); margin-bottom: var(--space-6); padding-bottom: var(--space-3); border-bottom: 2px solid var(--color-accent);">${cat.name}</h2>
            <div class="faq-list">
              ${cat.faqs.map((faq, i) => `
                <div class="faq-item" data-faq style="border: 1px solid var(--color-border-light); border-radius: var(--radius-lg); margin-bottom: var(--space-3); overflow: hidden; transition: box-shadow 0.3s ease;">
                  <button class="faq-trigger" style="width: 100%; padding: var(--space-5) var(--space-6); display: flex; align-items: center; justify-content: space-between; background: white; border: none; cursor: pointer; text-align: left; font-family: var(--font-body); font-size: var(--text-base); font-weight: var(--font-semibold); color: var(--color-text); gap: var(--space-4); transition: background 0.2s ease;">
                    <span>${faq.q}</span>
                    <span class="faq-icon" style="flex-shrink: 0; transition: transform 0.3s ease;">
                      ${icons.arrowRight}
                    </span>
                  </button>
                  <div class="faq-answer" style="max-height: 0; overflow: hidden; transition: max-height 0.3s ease;">
                    <div style="padding: 0 var(--space-6) var(--space-5); color: var(--color-text-muted); line-height: 1.7;">
                      ${faq.a}
                    </div>
                  </div>
                </div>
              `).join('')}
            </div>
          </div>
        `).join('')}
      </div>
    </section>

    <!-- CTA -->
    <section style="background: var(--color-primary-50); padding: var(--space-16) 0; text-align: center;">
      <div class="container">
        <h2 style="font-family: var(--font-heading); font-size: var(--text-3xl); margin-bottom: var(--space-4);">Still Have Questions?</h2>
        <p style="color: var(--color-text-muted); margin-bottom: var(--space-8);">Our team is happy to help. Reach out to us anytime.</p>
        <div style="display: flex; gap: var(--space-4); justify-content: center; flex-wrap: wrap;">
          <a href="/contact" class="btn btn-primary btn-lg">Contact Us</a>
          <a href="tel:+918220595978" class="btn btn-secondary btn-lg">${icons.phone} Call Now</a>
        </div>
      </div>
    </section>
  `;
}

export function initFAQPage() {
  // FAQ accordion toggle
  document.querySelectorAll('[data-faq] .faq-trigger').forEach(trigger => {
    trigger.addEventListener('click', () => {
      const item = trigger.closest('[data-faq]');
      const answer = item.querySelector('.faq-answer');
      const icon = item.querySelector('.faq-icon');
      const isOpen = answer.style.maxHeight && answer.style.maxHeight !== '0px';

      // Close all others
      document.querySelectorAll('[data-faq]').forEach(other => {
        if (other !== item) {
          other.querySelector('.faq-answer').style.maxHeight = '0px';
          other.querySelector('.faq-icon').style.transform = 'rotate(0deg)';
          other.style.boxShadow = '';
        }
      });

      if (isOpen) {
        answer.style.maxHeight = '0px';
        icon.style.transform = 'rotate(0deg)';
        item.style.boxShadow = '';
      } else {
        answer.style.maxHeight = answer.scrollHeight + 'px';
        icon.style.transform = 'rotate(90deg)';
        item.style.boxShadow = 'var(--shadow-md)';
      }
    });
  });

  // FAQ search
  const searchInput = document.getElementById('faq-search');
  if (searchInput) {
    searchInput.addEventListener('input', (e) => {
      const query = e.target.value.toLowerCase();
      document.querySelectorAll('[data-faq]').forEach(item => {
        const text = item.textContent.toLowerCase();
        item.style.display = text.includes(query) ? '' : 'none';
      });
    });
  }
}
